// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"ecb02c09","52":"14365184","53":"6f8c99f7","197":"a5bd0ac1","337":"aa4046ef","477":"69b7354e","587":"c6562154"}[chunkId] + ".js";
};